<div id="savingModalContent">{{message || 'Processing'}}...</div>
<div class="lds-ring"><div></div><div></div><div></div><div></div></div>